import React, { useState, useEffect } from 'react';
import LoadingOverlay from "react-loading-overlay";
import Loader from "react-loaders";
import { connect } from 'react-redux';
import { Card, Row, Col,Button,Input } from 'reactstrap';
import Download from '../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Download.svg'
import AddSubmissionsChatService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/AddSubmissionsChatService';
import FetchSubmissionsChatsService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchSubmissionsChatsService';
import xlsxIcon from '../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/xlsxIcon.svg'
import SubmissionAssetSatusChangeService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/SubmissionAssetSatusChangeService';
import ReactQuill from 'react-quill';
import { Editor, SetInnerHtmlWithClassReplacement } from '../../../../../../../../Utils/Constants';
import CustomModal from '../../../../../../../Components/Modals/CustomModal';
import AnnotationIcon from '../../../../../../../../designUtils/ProjectDashboard/AnnotationIcon.svg'
import {INIT_IMAGES,
  CURRENT_USER,
  uuid,
  TOOLS,
  // COLORS,} from './SubCompents/ImageAnnotations/HardCodeImageData';
  COLORS,} from '../AssetAnnotations/HardCodeImageData';
import SaveSubmissionsAssetsAnnonationService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/SaveSubmissionsAssetsAnnonationService';
// import AnnotationCanvas ,{PhotoDisplay} from './SubCompents/ImageAnnotations/ViewAndEditCanvas';
import AnnotationCanvas ,{PhotoDisplay} from '.././AssetAnnotations/AnnotationCanvas';
import FetchAssetsbySubmissionService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchAssetsbySubmissionService';

function CommentsDetailsComp(props){

  const [isExpanded, setIsExpanded] = useState(false)
  const [expandedNote, setExpandedNote] = useState(null);
  const handleQuillChange = (value, delta, source, editor) => {
    const plainText = editor.getText().trim();
    props.setComment(plainText === '' ? '' : value);
  };

  const replaceNoteText = SetInnerHtmlWithClassReplacement(props.noteList);
  const openNoteModal = (fullMessage) => {
      setExpandedNote(fullMessage);
      setIsExpanded(true);
  };
  const ReadMore = ({ htmlContent, maxLength, onReadMoreClick }) => {
      const isLong = htmlContent.length > maxLength;
      const truncatedContent = isLong ? htmlContent.substring(0, maxLength) + '...' : htmlContent;

      return (
          <div>
              <span
                  className="issue-description-set d-flex flex-wrap"
                  dangerouslySetInnerHTML={{ __html: truncatedContent }}
              />
              {isLong && (
                  <span
                      style={{ fontSize: '13px' }}
                      className="cursor-pointer d-flex justify-content-end text-primary"
                      onClick={() => onReadMoreClick(htmlContent)}
                  >
                      ....Read More
                  </span>
              )}
          </div>
      );
  };
return(
  <>
   <div className="p-3">
                 <div className="comment-input-container mt-2">
                   <ReactQuill
                     theme={'snow'}
                     modules={Editor.modules}
                     formats={Editor.formats}
                     value={props.comment}
                     onChange={handleQuillChange}
                     bounds={'.quill-prod'}
                     placeholder='Add Your Comments Here'/>
                 </div>
                 <div className="p-3 w-100 d-flex justify-content-end">
                          <Button
                              className="btn-background-color"
                              disabled={!props.comment}
                              onClick={() => props.addSubmissionsChats()}
                          >
                              Add Note
                          </Button>
                      </div>
                  <div className="comment-card rounded border">
                   {(props.noteList || []).length > 0 ? (
                     props.noteList.map((noteItem, index) => (
                       <div key={index}>
                         <div
                           className={`d-flex p-2 ${
                             noteItem.loggedInUser === 1 ? "justify-content-end" : "justify-content-start align-items-end"
                           }`}
                         >
                           <div className="d-flex align-items-start">
                           {props.selectedImage.loggedInUser !==noteItem.submittedBy ?
                            <div className="p-1 user-short-name">{noteItem.userShortName.toUpperCase()}</div>:''}
                             <p
                               className={`p-2 mb-0 ${
                                 noteItem.loggedInUser === 1 ? "chat-background-color-sent" : "chat-background-color"
                               }`}
                             >
                              <ReadMore htmlContent={noteItem.notes} maxLength={200} onReadMoreClick={openNoteModal}/>
                               <span className="float-right pt-1">{noteItem.submittedOn}</span>
                             </p>
                           </div>
                         </div>
                       </div>
                     ))
                   ) : (
                     <LoadingOverlay
                       active={props.loadScreen}
                       styles={{
                         overlay: (base) => ({
                           ...base,
                           background: "#f1f4f6",
                           opacity: 1,
                         }),
                         content: (base) => ({
                           ...base,
                           color: "#000",
                         }),
                       }}
                       spinner={<Loader active type="ball-pulse" />}
                       text="Loading chat details..."
                     >
                       <p className="text-muted px-2 mt-3">No Comments</p>
                     </LoadingOverlay>
                   )}
                 </div>
               </div>
               <CustomModal
                header={"Comment"}
                isOpen={isExpanded}
                toggle={() => setIsExpanded(!isExpanded)}
                size={"xl"}
                className="curve-popup"
              >
                 <p style={{ fontSize: "19px" }} className="issue-discription-set" dangerouslySetInnerHTML={{ __html: expandedNote || '' }} />
            </CustomModal>
  </>
)}

function ProjectDashDeliveriesImagesDetails(props) {
    const [noteList, setNoteList] = useState([]);
    const [loadScreen, setLoadScreen] = useState(false);
    const [expandedMessages, setExpandedMessages] = useState({});
    const [downloadAction, setDownloadAction] = useState(false);
    const [comment, setComment] = useState('');
    const [fileExtension,setFileExtension] = useState('');

    // State for Annotation Popup
    const [selectedTool, setSelectedTool] = useState('circle');
    const [selectedColor, setSelectedColor] = useState('#ff4444');
    const [annotationsPopup, setAnnotationsPopup] = useState(false);
    const [stagedAnnotations, setStagedAnnotations] = useState([]);
    const [originalAnnotations, setOriginalAnnotations] = useState([]);
    const [isCloseConfirmOpen, setIsCloseConfirmOpen] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [alertMsg,setAlertMsg]=useState('')


    useEffect(() => {
        if (!props.selectedImage) return;
        const fileExtension = props.selectedImage.filePath && props.selectedImage.filePath.toLowerCase().split('.').pop();
        setFileExtension(fileExtension)
        submissionsChats();
    }, [props.selectedImage]);

    const addSubmissionsChats = () => {
        const data = {
          notes: comment,
          assetId: props.selectedImage.assetId,
        };
        AddSubmissionsChatService(props.token, data).then((res) => {
          if (res) {
            setNoteList(res.noteList);
            setComment('');
          }
        });
    };
    
    const submissionsChats = () => {
        let data = {
          assetId: props.selectedImage.assetId
        }
        setLoadScreen(true);
        FetchSubmissionsChatsService(props.token, data).then((res) => {
          setNoteList(res);
          setLoadScreen(false);
        })
    };

    const handleDownloadImage = async (url) => {
        setDownloadAction(true);
        try {
          const response = await fetch(url, {
            method: 'GET',
            referrerPolicy: 'no-referrer',
            cache: 'no-store',
          });
          if (!response.ok) throw new Error(`Failed to fetch: ${url}`);
      
          const blob = await response.blob();
          const blobUrl = URL.createObjectURL(blob);
          const downloadLink = document.createElement('a');
          downloadLink.href = blobUrl;
          downloadLink.download = props.selectedImage.assetName || 'downloaded_file';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
      
          URL.revokeObjectURL(blobUrl);
        } catch (error) {
          console.error('Failed to download file:', error);
        } finally {
          setDownloadAction(false);
        }
    };
    const handleSubmissionAssetSatusChange=(status)=>{
      if (status === 13 && (!comment || comment.trim() === "")) {
        setAlertMsg("Note is mandatory to send this asset for rework.");
        return; // stop execution
      }
        let data={
          status:status,
          notes:comment?comment:'',
          assetId: props.selectedImage.assetId,
          submissionAssetId:props.submissionData.id,
          submissionFor:'',
          projectId:props.selectedProjectData.projectId,
        }

        SubmissionAssetSatusChangeService(props.token, data).then((res)=>{
          if(res){
            console.log(res);
            props.setAllAssetsList(res.assetetsDetails.assetList)
            const filterDoc=res.assetetsDetails.assetList && res.assetetsDetails.assetList.filter((assets)=>assets.assetSubCategory ==5)|| [];
            const filterGraphics=res.assetetsDetails.assetList && res.assetetsDetails.assetList.filter((assets)=>assets.assetSubCategory ==7)|| [];
            props.setGraphicsStatusCount(res.assetetsDetails && res.assetetsDetails.graphicsStatusCount);
            props.setDocumentStatusCount(res.assetetsDetails && res.assetetsDetails.documentStatusCount);
            
            if (props.action ==true){
              props.setAssetList(filterGraphics)

            }
            else{props.setAssetList(filterDoc)

            }
            // props.setAssetList(res.assetetsDetails.assetList)
            props.setSubmissionList(res.submissionDetails.submissionList)
            props.onClose()
          }
        })
    }

    // --- ANNOTATION LOGIC ---

    const handleAnnotaionPopup = () => {
        const cleanAnnotations = (props.selectedImage.annotations || []).map(({ isNew, isEdited, ...ann }) => ann);
        setOriginalAnnotations(cleanAnnotations);
        setStagedAnnotations(cleanAnnotations);
        setAnnotationsPopup(true);
    };

    const handleStageAnnotation = (coords, type, color, comment) => {
        const newAnnotationObject = {
            id: uuid(),
            type,
            color,
            coordinates: coords,
            comment,
            userName: props.loggedInUser,
            createdAt: new Date().toISOString(),
            isNew: true
        };
        setStagedAnnotations(prev => [...prev, newAnnotationObject]);
    };

    const handleStageEdit = (annotationId, newComment) => {
      if (!newComment || newComment.trim() === '') {
        return; 
      }
        setStagedAnnotations(prev =>
            prev.map(ann => {
                if (ann.id === annotationId) {
                    if (ann.comment === newComment) {
                        return ann;
                    }
                    return { ...ann, comment: newComment, isEdited: true };
                }
                return ann;
            })
        );
    };

    const handleStageDelete = (annotationId) => {
        setStagedAnnotations(prev => prev.filter(ann => ann.id !== annotationId));
    };
    
    const hasUnsavedChanges = JSON.stringify(originalAnnotations) !== JSON.stringify(stagedAnnotations);

    const handleSaveAllAnnotations = () => {
        if (!hasUnsavedChanges || isSaving) {
            return;
        }
        setIsSaving(true);

        const annotationsToSave = stagedAnnotations.map(({ isNew, isEdited, ...ann }) => ann);

        let data = {
            submissionFor:'',
            submissionAssetId: props.selectedImage.submissionId,
            assetId: props.selectedImage.assetId,
            submissionId: props.selectedImage.submissionDetailId,
            projectId: props.selectedProjectData.projectId,
            annotations: annotationsToSave
        };

        SaveSubmissionsAssetsAnnonationService(props.token, data).then((res) => {
            if (res) {
                props.setAssetList(res.assetList.assetList);
                props.setGraphicsStatusCount(res.assetList && res.assetList.graphicsStatusCount);
                props.setGraphicsTotal(res.assetList && res.assetList.graphicsTotal);
  
                props.setSubmissionList(res.submissionDetails.submissionList)
                const updatedImage = res.assetList.assetList.find(file => file.assetId === props.selectedImage.assetId);
                if (updatedImage) {
                    props.setSelectedImage(updatedImage);
                }
                setAnnotationsPopup(false);
            }
        }).catch(error => {
            console.error("Failed to save annotations:", error);
        }).finally(() => {
            setIsSaving(false);
        });
    };
    
    const handleCloseAnnotationPopup = () => {
        if (hasUnsavedChanges) {
            setIsCloseConfirmOpen(true);
        } else {
            setAnnotationsPopup(false);
        }
    };

    const handleDiscardAndClose = () => {
        setIsCloseConfirmOpen(false);
        setAnnotationsPopup(false);
    };

    const handleSaveAndClose = () => {
        handleSaveAllAnnotations();
        setIsCloseConfirmOpen(false);
    };
    
    const handleDeleteAndSaveAnnotation = (annotationId) => {
      const updatedAnnotations = stagedAnnotations.filter(ann => ann.id !== annotationId);

      setStagedAnnotations(updatedAnnotations);
      
      setOriginalAnnotations(updatedAnnotations);

      props.setSelectedImage({
          ...props.selectedImage,
          annotations: updatedAnnotations,
      });
      


      const annotationsToSave = updatedAnnotations.map(({ isNew, isEdited, ...ann }) => ann);
  
      let data = {
          submissionAssetId: props.selectedImage.submissionId,
          assetId: props.selectedImage.assetId,
          submissionId: props.selectedImage.submissionDetailId,
          projectId: props.selectedProjectData.projectId,
          annotations: annotationsToSave
      };
  
      SaveSubmissionsAssetsAnnonationService(props.token, data).then((res) => {
          if (res) {
              console.log("Background delete successful:", res);
              props.setAssetList(res.assetList.assetList);
              props.setSubmissionList(res.submissionDetails.submissionList);
  
              const updatedImage = res.assetList.assetList.find(file => file.assetId === props.selectedImage.assetId);
              if (updatedImage) {
                  props.setSelectedImage(updatedImage);
              }
          }
      }).catch(error => {
          console.error("Failed to delete and save annotation in background:", error);
      });
  };

    return (
      <>
        <Card className="p-3" style={{ position: 'relative' }}>
        <Row>
          <Col md={6}>
          <Card className="mb-3 p-3 qa-selected-image">

          {fileExtension === 'pdf' ? (
            <iframe
              src={props.selectedImage.filePath}
              title="PDF Preview"
              width="100%"
              height="500"
              style={{ border: 'none' }}
            ></iframe>
          ) : ['csv', 'docx', 'xlsx', 'xls', 'doc', 'xlsm'].includes(fileExtension) ? (
            <div className="xlx-file">
              <img src={xlsxIcon} alt="XLSX Icon" />
              <h5><b>Preview Not Available</b></h5>
            </div>
          ) : (
            <PhotoDisplay
              image={props.selectedImage}
              annotations={props.selectedImage&&props.selectedImage.annotations || []}
            />
          )}
          <div className="graphics-qa-id d-flex align-items-center justify-content-between mt-1">
              <div className="d-flex align-items-center">
              <span className="mr-3">
                  <b>{props.selectedImage.assetId}</b>
              </span>
              <span className="ml-2 comment-paragraph-task-storename"><b>{props.selectedImage.assetName}</b></span>
              </div>
              {!['pdf', 'docx', 'xlsx', 'xls', 'doc', 'xlsm', 'csv'].includes(fileExtension) && (
                <span className="text-danger">
                    #{props.selectedImage.amazonPosition || ''}
                </span>
              )}
              <div className="d-flex align-items-center">
              {props.action && props.action && props.selectedImage.status != 5? 
                    <button
                        title="Add Annotations"
                        className="info-button-background-none ml-2"
                        onClick={handleAnnotaionPopup}
                        >
                    <img src={AnnotationIcon}/>
                    </button> : ''}
              <button
                    onClick={() => handleDownloadImage(props.selectedImage.filePath, "DownloadeImage")}
                    className='info-button-background-none'
                    title='Download'
                  >
                    <img
                      className={`p-1 ${downloadAction === "DownloadeImage" ? 'button-img-background-download-inprogress' : 'button-img-background-download'}`}
                      src={Download}
                      alt='not found'
                    />
                  </button>
                  {downloadAction === "DownloadeImage" && <span className="ml-1">Downloading</span>}
              </div>
          </div>
          <div className="d-flex justify-content-between mt-1">
                <p className='mb-1'>{props.selectedImage.fileSize}</p>
                <p className='mb-1'>
                  Last Modified on : <b> {props.selectedImage.updatedAt} </b>
                </p>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
          <p className='mb-1'>
                Destination Category : <b> {props.selectedImage.destinationSubCategories} </b>
                </p>
               
                <div  className="d-flex gap-2">
                <span className='mr-1'>
                {(props.projectPermissions.ProjectAssetsDeliveries_ApprovedbyClient 
                && props.selectedImage.status != 5 
                && props.selectedImage.status != 15 
                && props.selectedImage.status != 16
                && props.selectedImage.status != 13) &&
            <Button 
            onClick={()=>handleSubmissionAssetSatusChange(5)}
            className="btn-send-approval">Approve</Button>}
                </span>
                <span>
                {(props.projectPermissions.ProjectAssetsDeliveries_ReWork 
                && props.selectedImage.status != 5 
                && props.selectedImage.status != 15 
                && props.selectedImage.status != 16
                && props.selectedImage.status != 13) &&
            <Button 
            onClick={()=>handleSubmissionAssetSatusChange(13)}
            className="btn-send-approval">Re-Work</Button>}
                </span>
                </div>
          </div>
          <div>
          <p className='mb-1 mt-1'>
                Asin List : <b> {props.selectedImage.asinList} </b>
                </p>
          </div>
          <span className="client-note">{alertMsg?alertMsg:''}</span>
          </Card>
         
          
          </Col>
  
          <Col md={6}>
                  <CommentsDetailsComp
                     setComment={setComment}
                     selectedImage={props.selectedImage}
                     comment={comment} 
                     noteList={noteList}
                     loadScreen={loadScreen}
                     addSubmissionsChats={addSubmissionsChats}
                  />
                </Col>
        </Row>
      </Card>
      <CustomModal
        isOpen={annotationsPopup}
        toggle={handleCloseAnnotationPopup}
        size={"xl"}
        header={<p title={props.selectedImage && props.selectedImage.assetName} className="comment-paragraph-Project-asin-title">{props.selectedImage && props.selectedImage.assetName}</p>}
       className='my-task-custom-module'
      >
        <Card>
        <div className="annotation-tools">
              <div className="tool-group">
                <span className="tool-label">Tools:</span>
                <div className="tool-options">
                  {TOOLS.map(tool => (
                    <button
                      key={tool.type}
                      className={`tool-btn ${selectedTool === tool.type ? 'active' : ''}`}
                      onClick={() => setSelectedTool(tool.type)}
                    >
                      {tool.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="color-group">
                <span className="color-label">Colors:</span>
                <div className="color-options">
                   {COLORS.map(color => (
                    <button
                      key={color}
                      className={`color-swatch ${selectedColor === color ? 'active' : ''}`}
                      style={{backgroundColor: color}}
                      onClick={() => setSelectedColor(color)}
                    />
                  ))}
                </div>
              </div>
              <Button
                className='btn-background-color ml-auto'
                onClick={handleSaveAllAnnotations}
                disabled={!hasUnsavedChanges || isSaving}
              >
                {isSaving ? 'Saving...' : 'Save All Changes'}
              </Button>
           </div>
         <AnnotationCanvas
              image={props.selectedImage}
              selectedTool={selectedTool}
              selectedColor={selectedColor}
              onStageAnnotation={handleStageAnnotation}
              annotations={stagedAnnotations}
              onEditAnnotation={handleStageEdit}
              onDeleteAnnotation={handleStageDelete}
              onDeleteAndSave={handleDeleteAndSaveAnnotation}
            />
        </Card>
      </CustomModal>

      <CustomModal
        isOpen={isCloseConfirmOpen}
        toggle={() => setIsCloseConfirmOpen(false)}
        size={"md"}
        className="curve-popup"
        header={"Unsaved Changes"}
      >
        <Card className="curve-popup p-3 ">
          <Row>
            <Col md={12}>
              <div>
                <h6>Do you want to save changes before proceeding?</h6>
              </div>
              <div className='mb-2 mt-4 d-flex justify-content-end'>
                <Button
                  className=" no-btn-background-color mr-2"
                  onClick={handleDiscardAndClose}
                >
                  No
                </Button>
                <Button
                  className='btn-background-color'
                  onClick={handleSaveAndClose}
                >
                  Save
                </Button>
              </div>
            </Col>
          </Row>
        </Card>
      </CustomModal>
      </>
    );
}

const mapStateToProps = (state) => ({
token: state.loggedUser.token,
storeOverview: state.accountOverview.store.storeOverview,
});

export default connect(mapStateToProps)(ProjectDashDeliveriesImagesDetails);